import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import { ReconfigureAgentPanelDataProvider } from '../dataProvider/ReconfigureAgentPanelDataProvider';

export class ReconfigureAgentPanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, ReconfigureAgentPanelDataProvider);
  }
}
